import { Spinner } from '@7shifts/sous-chef';
import { lazy, Suspense } from 'react';
import ErrorBoundary from 'sharedComponents/ErrorBoundary';

const TemplatesPage = lazy(() => import('./pages/TemplatesPage'));

export const ROUTES = [
    {
        path: '/templates',
        element: (
            <Suspense fallback={<Spinner block />}>
                <TemplatesPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
